import { useContext, useCallback } from "react";

import { useHistory } from "react-router-dom";

import { ClienteContext } from "../../context/ClienteContext";
import MaskService from "../../utils/mask/maskService";
import { validNotNull, validEmail } from "../../utils/validations";
import {
  createCertificadoCliente,
  createCliente,
  updateCliente,
} from "../../repository/ERP/prouser/ClienteService";

// nova rota da api
import { findClienteByCpfCnpj } from "../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";

import { QueryParamsContext } from "../../context/QueryParamsContext";
import { notify } from "../../utils/notify";
import Swal from "sweetalert2";
import {
  findByCEP,
  findByCNPJ,
  findByCPF,
} from "../../repository/services/BigDataService";
import { ImutaveisContext } from "../../context/ImutaveisContext";

export default function useClienteController() {
  const {
    tipoInscricao,
    setTipoInscricao,
    numInscricao,
    setNumInscricao,
    numInscricaoEstadual,
    setNumInscricaoEstadual,
    numInscricaoMunicipal,
    setNumInscricaoMunicipal,
    ccm,
    setCcm,
    nome,
    setNome,
    email,
    setEmail,
    setLoadingCheckbox,
    checkboxCertificado,
    setCheckboxCertificado,
    setPasswordCertificate,
    passwordCertificate,
    setOpenModalCertificado,
    setFile,
    file,
    setChangeCertificate,
    changeCertificate,

    pais,
    setPais,
    cep,
    setCep,
    uf,
    setUf,
    cidade,
    setCidade,
    logradouro,
    setLogradouro,
    complemento,
    setComplemento,
    bairro,
    setBairro,

    setLoading,
    setErrors,
  } = useContext(ClienteContext);
  const { optionsEstado, optionsMunicipio } = useContext(ImutaveisContext);
  const { queryParams } = useContext(QueryParamsContext);
  const { push, goBack } = useHistory();

  const handleTipoInscricao = useCallback(
    (prop) => {
      setTipoInscricao(prop);
      setNumInscricao("");
    },
    [setTipoInscricao, setNumInscricao]
  );

  const handleCep = useCallback(
    (prop) => {
      const newCep = MaskService.toMask("cep", prop.target.value);

      setCep(newCep);

      const getData = async () => {
        try {
          setLoading(true);
          const response = await findByCEP(prop.target.value);
          const responseData = response?.data;

          if (
            response.success &&
            responseData.statusCode === 200 &&
            responseData.data
          ) {
            setUf(
              (current) =>
                optionsEstado.find(
                  (opt) => opt.estado === responseData.data.stateCode
                ) || current
            );
            setLogradouro(
              (current) => current || responseData.data.street.substring(0, 120)
            );
            setBairro(
              (current) =>
                responseData.data.neighborhood.substring(0, 60) || current
            );
            setComplemento(
              (current) =>
                responseData.data.additionalInfo.substring(0, 50) || current
            );
            setCidade(
              (current) =>
                optionsMunicipio.find(
                  (opt) => opt.codigo === responseData.data.ibgeCode
                ) || current
            );
            return;
          }

          notify("CEP não encontrado.");
        } catch (error) {
          notify("CEP não encontrado.");
        } finally {
          setLoading(false);
        }
      };

      if (newCep.length === 10) {
        document.activeElement.blur();
        getData();
      }
    },
    [
      setLoading,
      setCep,
      optionsEstado,
      optionsMunicipio,
      setBairro,
      setCidade,
      setComplemento,
      setLogradouro,
      setUf,
    ]
  );

  const handleNumInscricao = useCallback(
    ({ prop, birthDate, tipoInscricaoProp = { descricao: "CNPJ" } }) => {
      const newNumInscricao = MaskService.toMask(
        tipoInscricaoProp.descricao.toLowerCase(),
        prop.target.value
      );
      setNumInscricao(newNumInscricao);

      const getData = async () => {
        try {
          setLoading(true);
          if (
            tipoInscricaoProp.descricao.toLowerCase() === "cnpj" &&
            newNumInscricao.length === 18
          ) {
            document.activeElement.blur();

            const customerExists = await findClienteByCpfCnpj(
              queryParams.empresa_cnpj,
              prop.target.value.replace(/[^0-9]+/g, "")
            );

            if (customerExists.success && customerExists.data.length > 0) {
              setNumInscricao("");
              return notify("Já existe um cliente com este Nº de inscrição.");
            }

            const response = await findByCNPJ(prop.target.value);
            const responseData = response?.data;

            if (
              response.success &&
              responseData.statusCode === 200 &&
              responseData.data
            ) {
              setNome(responseData.data.corporate_name.substring(0, 50));

              handleCep({
                target: { value: responseData.data.addresses[0].postalCode },
              });
              setLogradouro(
                `${responseData.data.addresses[0].street},${responseData.data.addresses[0].number}`.substring(
                  0,
                  120
                )
              );

              setUf(
                optionsEstado.find(
                  (opt) =>
                    opt.estado === responseData.data.addresses[0].stateCode
                ) || null
              );
              setComplemento(
                responseData.data.addresses[0].additionalInfo.substring(0, 50)
              );
              setBairro(responseData.data.addresses[0].bairro.substring(0, 60));
              return;
            }
            notify(
              "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
            );
          } else if (
            tipoInscricaoProp.descricao.toLowerCase() === "cpf" &&
            newNumInscricao.length === 14
          ) {
            document.activeElement.blur();

            const customerExists = await findClienteByCpfCnpj(
              queryParams.empresa_cnpj,
              prop.target.value
            );
            if (customerExists.success && customerExists.data.length > 0) {
              setNumInscricao("");
              return notify("Já existe um cliente com este Nº de inscrição.");
            }

            const response = await findByCPF(prop.target.value, birthDate);
            const responseData = response?.data;

            if (
              response.success &&
              responseData.statusCode === 200 &&
              responseData.data
            ) {
              setNome(responseData.data.name.substring(0, 50));
              return;
            }
            notify(
              "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
            );
          }
        } catch (error) {
          notify(
            "Não foi possível realizar o autopreenchimento, certifique-se de que o N° de Inscrição é válido."
          );
        } finally {
          setLoading(false);
        }
      };

      getData();
    },
    [
      queryParams.empresa_cnpj,
      setLoading,
      setNumInscricao,
      handleCep,
      optionsEstado,
      setBairro,
      setComplemento,
      setLogradouro,
      setNome,
      setUf,
    ]
  );

  const handleNumInscricaoEstadual = useCallback(
    (prop) => {
      setNumInscricaoEstadual(prop.target.value.substring(0, 20));
    },
    [setNumInscricaoEstadual]
  );

  const handleNumInscricaoMunicipal = useCallback(
    (prop) => {
      setNumInscricaoMunicipal(prop.target.value.substring(0, 15));
    },
    [setNumInscricaoMunicipal]
  );

  const handleCcm = useCallback(
    (prop) => {
      setCcm(prop.target.value.substring(0, 30));
    },
    [setCcm]
  );

  const handleNome = useCallback(
    (prop) => {
      setNome(prop.target.value.substring(0, 50));
    },
    [setNome]
  );

  const handleEmail = useCallback(
    (prop) => {
      setEmail(prop.target.value.substring(0, 50));
    },
    [setEmail]
  );

  const handlePais = useCallback(
    (prop) => {
      setPais(prop);
    },
    [setPais]
  );

  const handleUf = useCallback(
    (prop) => {
      setUf(prop);
    },
    [setUf]
  );

  const handleCidade = useCallback(
    (prop) => {
      setCidade(prop);
    },
    [setCidade]
  );

  const handleLogradouro = useCallback(
    (prop) => {
      setLogradouro(prop.target.value.substring(0, 120));
    },
    [setLogradouro]
  );

  const handleComplemento = useCallback(
    (prop) => {
      setComplemento(prop.target.value.substring(0, 60));
    },
    [setComplemento]
  );

  const handleBairro = useCallback(
    (prop) => {
      setBairro(prop.target.value.substring(0, 60));
    },
    [setBairro]
  );

  const handleChangeCheckContador = () => {
    setCheckboxCertificado({
      contador: true,
      cliente: false,
    });
  };

  const handleChangeCheckCliente = () => {
    setCheckboxCertificado({
      contador: false,
      cliente: true,
    });

    setOpenModalCertificado(true);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const resultValidation = validNotNull([
        { value: numInscricao, key: "numInscricao" },
        { value: nome, key: "nome" },
        { value: email, key: "email" },

        { value: pais, key: "pais" },
        { value: cep, key: "cep" },
        { value: uf, key: "uf" },
        { value: cidade, key: "cidade" },
        { value: logradouro, key: "logradouro" },
        { value: bairro, key: "bairro" },
      ]);

      if (
        numInscricao &&
        tipoInscricao &&
        !MaskService.isValid(
          tipoInscricao.descricao.toLowerCase(),
          numInscricao
        )
      ) {
        resultValidation.errorsValidation.numInscricao =
          "N° de inscrição inválido";
        resultValidation.error = true;
      }

      if (cep && !MaskService.isValid("cep", cep)) {
        resultValidation.errorsValidation.cep = "CEP inválido";
        resultValidation.error = true;
      }

      if (email && !validEmail(email)) {
        resultValidation.errorsValidation.email = "E-mail inválido";
        resultValidation.error = true;
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);

        return notify("Verifique se os campos obrigatórios estão preenchidos.");
      }

      const resultPost = await createCliente(queryParams.empresa_cnpj, {
        cliente: {
          cpfcnpj: numInscricao.replace(/[^0-9]+/g, ""),
          ie: numInscricaoEstadual,
          inscricao_municipal: numInscricaoMunicipal,
          ccm,
          apelido: nome,
          razao: nome,
          email,
          usar_certificado_cliente: checkboxCertificado.cliente ? "1" : "0",
          clientdevi: "N",
          idpais: pais.codigo,
          cep: cep.replace(/[^0-9]+/g, ""),
          id_estado: uf.id,
          cidade: cidade.municipio,
          municipio_codigo: cidade.codigo,
          endereco: logradouro,
          bairro,
          complemento,
        },
      });

      if (resultPost.success) {
        if (checkboxCertificado.cliente) {
          const resultCertificate = await createCertificadoCliente({
            cnpj_cpf: numInscricao.replace(/[^0-9]+/g, ""),
            certificado: checkboxCertificado.cliente && file ? file.b64 : null,
            password:
              checkboxCertificado.cliente && passwordCertificate
                ? passwordCertificate
                : null,
          });

          if (!resultCertificate || !resultCertificate.success)
            notify("Não foi possível salvar o certificado.", true, "warning");
        }

        Swal.fire({
          icon: "success",
          text: "Registro salvo com sucesso.",
          showConfirmButton: true,
          timer: 3000,
        });

        handleClearContext();
        return goBack();
      }

      notify("Não foi possível salvar este cliente.");
    } catch (error) {
      notify("Não foi possível salvar este cliente.");
      console.error("ERROR handleSubmit ClienteController", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitEdit = async (location) => {
    try {
      setLoading(true);

      const row = location && location.state ? JSON.parse(location.state) : {};

      const resultValidation = validNotNull([
        { value: numInscricao, key: "numInscricao" },
        { value: nome, key: "nome" },
        { value: email, key: "email" },

        { value: pais, key: "pais" },
        { value: cep, key: "cep" },
        { value: uf, key: "uf" },
        { value: cidade, key: "cidade" },
        { value: logradouro, key: "logradouro" },
        { value: bairro, key: "bairro" },
      ]);

      if (
        numInscricao &&
        tipoInscricao &&
        !MaskService.isValid(
          tipoInscricao.descricao.toLowerCase(),
          numInscricao
        )
      ) {
        notify("N° de inscrição inválido");
        resultValidation.errorsValidation.numInscricao =
          "N° de inscrição inválido";
        resultValidation.error = true;
      }

      if (cep && !MaskService.isValid("cep", cep)) {
        notify("CEP inválido");
        resultValidation.errorsValidation.cep = "CEP inválido";
        resultValidation.error = true;
      }

      if (email && !validEmail(email)) {
        notify("E-mail inválido");
        resultValidation.errorsValidation.email = "E-mail inválido";
        resultValidation.error = true;
      }

      if (resultValidation.error) {
        setErrors(resultValidation.errorsValidation);
        return notify("Verifique se os campos obrigatórios estão preenchidos.");
      }

      const resultCustomer = await updateCliente(
        row.id,
        queryParams.empresa_cnpj,
        {
          cliente: {
            cpfcnpj: numInscricao.replace(/[^0-9]+/g, ""),
            ie: numInscricaoEstadual,
            inscricao_municipal: numInscricaoMunicipal,
            ccm,
            apelido: nome,
            razao: nome,
            email,
            usar_certificado_cliente: checkboxCertificado.cliente ? "1" : "0",
            clientdevi: "N",
            idpais: pais.codigo,
            cep: cep.replace(/[^0-9]+/g, ""),
            id_estado: uf.id,
            cidade: cidade.municipio,
            municipio_codigo: cidade.codigo,
            endereco: logradouro,
            bairro,
            complemento,
          },
        }
      );

      if (resultCustomer.success) {
        const bodyCertificate = {
          cnpj_cpf: numInscricao.replace(/[^0-9]+/g, ""),
        };

        if (changeCertificate.file) {
          bodyCertificate.certificado =
            checkboxCertificado.cliente && file ? file.b64 : null;
        }

        if (changeCertificate.password) {
          bodyCertificate.password =
            checkboxCertificado.cliente && passwordCertificate
              ? passwordCertificate
              : null;
        }

        if (bodyCertificate.certificado || bodyCertificate.password) {
          const resultCertificate = await createCertificadoCliente(
            bodyCertificate
          );

          if (!resultCertificate || !resultCertificate.success) {
            notify(
              "Não foi possível atualizar o certificado.",
              true,
              "warning"
            );
          }
        }

        Swal.fire({
          icon: "success",
          text: "Registro editado com sucesso.",
          showConfirmButton: true,
          timer: 3000,
        });

        handleClearContext();
        return goBack();
      }

      notify("Não foi possível editar este cliente.");
    } catch (error) {
      notify("Não foi possível editar este cliente.");
      console.error("ERROR handleSubmit ClienteController", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearContext = useCallback(() => {
    setTipoInscricao({ descricao: "CNPJ" });
    setNumInscricao("");
    setNumInscricaoEstadual("");
    setNumInscricaoMunicipal("");
    setCcm("");
    setNome("");
    setEmail("");
    setFile(null);
    setChangeCertificate({});
    setLoadingCheckbox(false);
    setCheckboxCertificado({
      contador: true,
      cliente: false,
    });
    setOpenModalCertificado(false);
    setPasswordCertificate("");

    setPais({ codigo: "1058", descricao: "BRASIL" });
    setCep("");
    setUf(null);
    setCidade(null);
    setLogradouro("");
    setComplemento("");
    setBairro("");

    setErrors({});
  }, [
    setBairro,
    setCcm,
    setCep,
    setCidade,
    setComplemento,
    setEmail,
    setChangeCertificate,
    setCheckboxCertificado,
    setFile,
    setLoadingCheckbox,
    setOpenModalCertificado,
    setPasswordCertificate,
    setErrors,
    setLogradouro,
    setNome,
    setNumInscricao,
    setNumInscricaoEstadual,
    setNumInscricaoMunicipal,
    setPais,
    setTipoInscricao,
    setUf,
  ]);

  const handleCancel = () => {
    handleClearContext();
    push("listagem");
  };

  const handleOpenInsert = () => {
    push("cadastro");
  };

  return {
    handleNumInscricao,
    handleTipoInscricao,
    handleNumInscricaoEstadual,
    handleNumInscricaoMunicipal,
    handleCcm,
    handleNome,
    handleEmail,
    handleChangeCheckContador,
    handleChangeCheckCliente,

    handlePais,
    handleCep,
    handleUf,
    handleCidade,
    handleLogradouro,
    handleComplemento,
    handleBairro,

    handleSubmit,
    handleSubmitEdit,
    handleCancel,
    handleClearContext,

    handleOpenInsert,
  };
}
